interface Partner {
  id: number
  name: string
  logo: string
  website?: string
}

interface PartnersProps {
  partners: Partner[]
  title?: string
}

const Partners = ({ partners, title = 'Our Partners & Sponsors' }: PartnersProps) => {
  // Don't render if no partners
  if (!partners || partners.length === 0) {
    return null
  }

  return (
    <section className="bg-gray-900 py-12 md:py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-primary-light text-sm md:text-base font-semibold uppercase tracking-wider">
              Partners
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mt-4 mb-6">
              {title}
            </h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 items-center">
            {partners.map((partner) => (
              <div
                key={partner.id}
                className="flex items-center justify-center p-4 md:p-6 bg-gray-800 rounded-lg hover:bg-gray-700 transition-all duration-300 hover:scale-105 border border-gray-700 hover:border-primary-light/50"
              >
                {partner.website ? (
                  <a
                    href={partner.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full h-16 md:h-20 flex items-center justify-center"
                  >
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="max-w-full max-h-16 md:max-h-20 object-contain opacity-80 hover:opacity-100 transition-opacity"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement
                        target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(partner.name)}&background=2563EB&color=fff&size=128`
                      }}
                    />
                  </a>
                ) : (
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="max-w-full max-h-16 md:max-h-20 object-contain opacity-80"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement
                      target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(partner.name)}&background=2563EB&color=fff&size=128`
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Partners

